/*
*
* File JS per la Pagina Single Immobili
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import anchorMenu from 'components/anchor-menu/anchor-menu';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import twoColumns from 'components/two-columns/two-columns';
import share from 'components/share/share';
import smoothScroll from '../../js/utilities/smooth-scroll';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import 'lightgallery/css/lightgallery.css'
import 'lightgallery/css/lg-video.css'
import './single-immobili.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//


addEventListener('DOMContentLoaded', (evt) =>
{
    const allLightGallery = document.querySelectorAll('.immobile__gallery');
    const allButtonOpenGallery = document.querySelectorAll('[data-lg-gallery]');
    const firstThumbGallery = {};

    if( allLightGallery.length )
    {
        allLightGallery.forEach(gallery =>
        {
            let options =
            {
                licenseKey: '',
                speed: 500,
                download: false
            };

            if( gallery.dataset.typeGallery === 'video' )
            {
                options['plugins'] = [lgVideo];
            }

            lightGallery(gallery, options);

            if( gallery.hasAttribute('id') )
            {
                firstThumbGallery[gallery.id] = gallery.querySelector('.immobile__gallery-thumb');
            }
        });
    }

    if( allButtonOpenGallery.length )
    {
        allButtonOpenGallery.forEach(button =>
        {
            button.addEventListener('click', evt=>
            {
                let id = button.dataset.lgGallery;
                
                if( firstThumbGallery.hasOwnProperty(id) )
                {
                    if(firstThumbGallery[id])
                    {
                        firstThumbGallery[id].click();
                    }
                }
            });
        });
    }

    share();
    smoothScroll();
});


//--------------------------------------------------------------------//